module.exports = __webpack_public_path__ + "img/smart-room-2.f18febf8.png";